export const REQUEST_STATES = Object.freeze({
    SENDING: "request.sending",
    ERROR: "request.error",
    SENT: "request.sent",
    NONE: "request.none",
});

export const BASKET_ITEM_STATES = Object.freeze({
    CONFIRMED: "Confirmed",
    CANCELED: "Canceled",
});

export const FETCH_STATES = Object.freeze({
    FETCHING: "fetch.fetching",
    FETCHED: "fetch.fetched",
    ERROR: "fetch.error",
});

export const ERRORS = Object.freeze({
    CREATE_TABLE: "error.create.table",
    CREATE_SEND: "error.create.send",
    EDIT_TABLE: "error.edit.table",
    EDIT_SEND: "error.edit.send",
    GET_BASKET: "error.get.basket",
    GET_LIST: "error.get.list",
});

export const ERROR_MESSAGES = Object.freeze({
    STORE_NO_CPTY: "Type in your counterparty name",
});

export const SETTING_KEYWORDS = Object.freeze({
    SORT: "sort",
    FILTER: "filter",
    GROUP: "group",
    SCROLL: "scroll",
    EDIT: "edit",
});

export const DEFAULT_CCY_OPTIONS = ["EUR", "GBP", "JPY", "KRW", "TWD", "USD"];

export const INTERMEDIARY_LABELS = Object.freeze({
    Any: "Any",
    Ksd: "KSD",
    Ksfc: "KSFC",
    Ksda: "KSDA",
});

export const INTERMEDIARY_OPTIONS = [null, "KSD", "KSFC", "KSDA"];
export const INTERMEDIARY_SELECT_TYPES = Object.freeze({
    ANY: "ANY",
    KSD: "KSD",
    KSDA: "KSDA",
    KSFC: "KSFC",
});

export const HUMANIZED_INTERMEDIARY = Object.freeze({
    ANY: "Any",
    KSD: "KSD",
    KSDA: "KSDA",
    KSFC: "KSFC",
});

export const CONFIRM_EDIT_MODE = Object.freeze({
    OFF_WITH_SAVE: 0,
    OFF_WITHOUT_SAVE: 1,
    ON: 2,
});

export const TX_TYPE_VALUES = Object.freeze({
    ANY: "ANY",
    ARRANGED: "ARRANGED",
    BID_OFFER: "BID_OFFER",
    CUSTOMIZED: "CUSTOMIZED",
    FAIL_COVER: "FAIL_COVER",
});

export const HUMANIZED_TX_TYPES = Object.freeze({
    ANY: "Any",
    ARRANGED: "Arranged",
    BID_OFFER: "Bid-Offer",
    CUSTOMIZED: "Customized",
    FAIL_COVER: "Fail-Cover",
});

export const HUMANIZED_SETTLEMENT_STATUSES = Object.freeze({
    PENDING: "Pending",
    SUBMITTING: "Submitting",
    SUBMITTED: "Submitted",
    RECEIVED: "Received",
    APPROVED: "Approved",
    REJECTED: "Rejected",
    MATCHED: "Matched",
    SETTLED: "Settled",
    EXPIRED: "Expired",
    CANCELED: "Canceled",
    ERROR: "Error",
    REPLACED: "Replaced",
});

export const CUSTODY_ASSET_TYPE_KEYS = ["", "01", "02", "03", "60"];

export const CUSTODY_ASSET_TYPES = Object.freeze({
    "": "-",
    "01": "01: Own Asset",
    "02": "02: Investor Asset",
    "03": "03: Trust Asset",
    60: "60: Asset Management",
});

// for confirmation only
export const TX_TYPE_LABELS = Object.freeze({
    Any: "Any",
    BidOffer: "Bid-Offer",
    FailCover: "Fail-Cover",
    Arranged: "Arranged",
    Customized: "Customized",
});

export const TX_PURPOSE_LABELS = Object.freeze({
    NONE: {
        label: "-",
        value: "-",
    },
    SHORT_SELLING: {
        label: "Short Selling",
        value: "ShortSelling",
    },
});

/**
 * Status labels the Records grid shows. A status absent here falls back to the
 * raw value title-cased, which reads correctly for every other state.
 *
 * The grid's set filter lists these labels while the server is queried with the
 * raw value, so `formatStatus` and `rawStatus` have to stay inverses of each
 * other.
 */
export const HUMANIZED_CONFIRMATION_STATES = Object.freeze({
    CONFIRMED: "Recorded",
});

const RAW_CONFIRMATION_STATES = Object.freeze(
    Object.fromEntries(
        Object.entries(HUMANIZED_CONFIRMATION_STATES).map(([raw, label]) => [
            label,
            raw,
        ])
    )
);

/** A raw status as the Records grid shows it. */
export const formatStatus = (value) =>
    value
        ? HUMANIZED_CONFIRMATION_STATES[value] ||
          value.charAt(0) + value.slice(1).toLowerCase()
        : "";

/** A label from the status filter, back to the status the server knows. */
export const rawStatus = (label) =>
    RAW_CONFIRMATION_STATES[label] || label.toUpperCase();
